import { request, Response } from '../utils';
import { GraphPermissions, Session } from '../types';

export const readGraphPermissions = (body: {
  session: Session;
  graphID: string;
}): Response<GraphPermissions> => request('read-graph-permissions', body);
